export default "__VITE_ASSET__3130aed2__"